import { Fragment, useState } from "react";
import ActionDelete from "@material-ui/icons/Delete";
import classnames from "classnames";
import { Button } from "react-admin";
import DeleteOrdersConfirmationModal from "./DeleteOrdersConfirmationModal";


const DeleteOrderButton = (props) => {
  const [showDialog, setShowDialog] = useState(false);
  const {selectedIds} = props;

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const { label = "ra.action.delete", classes = {}, className } = props;
  return (
    <Fragment>
      <Button
        onClick={() => handleClick()}
        label={label}
        className={classnames("ra-delete-button", classes.deleteButton, className)}
        key="button"
      >
        <ActionDelete />
      </Button>
      <DeleteOrdersConfirmationModal
        open={showDialog}
        onClose={handleCloseClick}
        orderIds={selectedIds}
      />
    </Fragment>
  );
};

export default DeleteOrderButton;
